import {
  OBJECT_TYPE_ACL_TEMPLATES,
  OBJECT_TYPE_ASSETS,
  OBJECT_TYPE_COLLECTIONS,
  OBJECT_TYPE_CUSTOM_ACTIONS,
  OBJECT_TYPE_EXPORT_LOCATIONS,
  OBJECT_TYPE_GROUPS,
  OBJECT_TYPE_METADATA_VIEWS,
  OBJECT_TYPE_PLAYLISTS,
  OBJECT_TYPE_PORTALS,
  OBJECT_TYPE_SAVED_SEARCHES,
  OBJECT_TYPE_SEARCH_VIEWS,
  OBJECT_TYPE_STORAGES,
  OBJECT_TYPE_TRANSCODERS,
  OBJECT_TYPE_USERS,
} from '@iconik-io/iconik-api/src/types/object_types';

export const ACL_TYPE_OWN = 'OWN';
export const ACL_TYPE_INHERITED = 'INHERITED';
export const ACL_TYPE_PROPAGATED = 'PROPAGATED';

export const aclPrefixes = [
  OBJECT_TYPE_ACL_TEMPLATES,
  OBJECT_TYPE_ASSETS,
  OBJECT_TYPE_COLLECTIONS,
  OBJECT_TYPE_CUSTOM_ACTIONS,
  OBJECT_TYPE_EXPORT_LOCATIONS,
  OBJECT_TYPE_GROUPS,
  OBJECT_TYPE_METADATA_VIEWS,
  OBJECT_TYPE_SEARCH_VIEWS,
  OBJECT_TYPE_SAVED_SEARCHES,
  OBJECT_TYPE_STORAGES,
  OBJECT_TYPE_TRANSCODERS,
  OBJECT_TYPE_USERS,
  OBJECT_TYPE_PLAYLISTS,
  OBJECT_TYPE_PORTALS,
] as const;
